import { EEvaluationStatus, IEvaluations, IEvaluationStatics } from "../interfaces/IEvaluation";



export const calculateEvaluationStatus = (value: IEvaluations[any]) => {
    let status;

    if (value.status === EEvaluationStatus.Okay) {
        status = EEvaluationStatus.Okay
    } else if (value.status === EEvaluationStatus.NotOkay) {
        status = EEvaluationStatus.NotOkay
    } else if (value.status === EEvaluationStatus.Uknown) {
        status = EEvaluationStatus.Uknown
    } else if (value.okay && value.okay >= 1 && (!value.notOkay || value.okay < 1)) {
        status = EEvaluationStatus.Okay
    } else if (value.notOkay || (typeof value.notOkay !== "undefined" && value.notOkay > 1)) {
        status = EEvaluationStatus.NotOkay
    }

    return status;
}



export const calculateEvaluationStatics = (data: IEvaluations) => {

    const checkKeys = Object.keys(data);

    const statics = checkKeys.reduce<IEvaluationStatics>((acc, key) => {

        const { status, okay, notOkay } = data[key] || {};


        // Add one okay if no notOkays and even one okay
        if (typeof okay !== "undefined" && typeof notOkay !== "undefined") {
            if (notOkay > 0) {
                acc.notOkay = acc.notOkay + 1
            } else if (okay > 0) {
                acc.okay = acc.okay + 1
            }
        };

        // Add one by status
        if (typeof status !== "undefined") {
            switch (status) {
                case EEvaluationStatus.Okay:
                    acc.okay = acc.okay + 1
                    break;
                case EEvaluationStatus.NotOkay:
                    acc.notOkay = acc.notOkay + 1
                    break;
                case EEvaluationStatus.Uknown:
                    acc.uknown = acc.uknown + 1
                    break;
            }
        };

        return acc
    }, { okay: 0, notOkay: 0, uknown: 0 });

    return statics;

};

